import { useEffect, useRef } from 'react';
import { ChatMessages } from './ChatMessages';
import { SuggestionChips } from './SuggestionChips';
import { MessageInput } from './MessageInput';
import { useAskGuide, useGuideMessages, useMe } from '../../store/queryHooks';
import { ClientApiError } from '../../lib/apiError';
import { useUiStore } from '../../store/ui';
import styles from './GuidePage.module.css';

export function GuidePage() {
  const { year, month, setToast } = useUiStore();
  const messages = useGuideMessages();
  const ask = useAskGuide();
  const me = useMe();
  const scroller = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (scroller.current) {
      scroller.current.scrollTop = scroller.current.scrollHeight;
    }
  }, [messages.data, ask.isPending]);

  const keySet = me.data?.gemini_key_set ?? false;

  async function onSend(text: string) {
    if (!keySet) {
      setToast('Sæt en Gemini-nøgle i indstillinger først');
      return;
    }
    try {
      await ask.mutateAsync({ text, year, month });
    } catch (err) {
      if (err instanceof ClientApiError) {
        if (err.code === 'gemini_key_invalid') {
          setToast('Ugyldig eller manglende Gemini-nøgle');
        } else if (err.code === 'gemini_rate_limit') {
          setToast('For mange henvendelser lige nu — prøv om lidt');
        } else {
          setToast('Guiden kunne ikke svare');
        }
      } else {
        setToast('Der skete en fejl');
      }
    }
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.headerBadge}>B</div>
        <div>
          <div className={styles.headerTitle}>Økonomi-guide</div>
          <div className={styles.headerSub}>
            Drevet af Gemini · svarene her er baseret på jeres tal
          </div>
        </div>
      </div>
      <div className={styles.body} ref={scroller}>
        <ChatMessages messages={messages.data?.messages ?? []} />
        {ask.isPending && (
          <div className={styles.typing}>
            <div className={styles.typingBubble}>
              <span className={styles.dot} />
              <span className={styles.dot} />
              <span className={styles.dot} />
            </div>
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <SuggestionChips onPick={onSend} />
        <MessageInput onSend={onSend} disabled={ask.isPending} />
      </div>
    </div>
  );
}
